import React, { useState, useEffect, Fragment } from "react";
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from './../../Helpers/Settings.js';
import { ToastContainer, toast } from "react-toastify";
import Swal from 'sweetalert2'
import PageTitle from "../../Components/PageTitle.js";
import "react-toastify/dist/ReactToastify.css";
import JoditEditor from 'jodit-react';
import { joditToolbar } from './../../Helpers/JoditToolbar.js';
import { decodeToken, isExpired } from "react-jwt";

const Ayar = () => {
    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(null);
    const [yetkiKaydet, setYetkiKaydet] = useState(false);

    const [tab, setTab] = useState('Metin');

    const [kisiGizlilikMetni, setKisiGizlilikMetni] = useState('');
    const [genelCevapMetni, setGenelCevapMetni] = useState('');
    const [mailSablonYeniSifre, setMailSablonYeniSifre] = useState('');
    const [mailSablonSifreYenileme, setMailSablonSifreYenileme] = useState('');
    const [mailSablonBildirim, setMailSablonBildirim] = useState('');

    useEffect(() => {
        getAcilisData();
    }, []);

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);
            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    const getAcilisData = async () => {
        if (tokenYenile() === false) {
            return;
        }
        
        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("Ayarlar - Genel Ayarlar - Gör");

        setYetkiGor(tempYetkiGor);

        if (tempYetkiGor === true) {
            setYetkiKaydet(await AuthService.getYetkiKontrolByYetki("Ayarlar - Genel Ayarlar - Kaydet"));
            await getData();
        }
    }

    const getData = async () => {
        try {
            const result = await axios.get(settings.ApiUrl + 'Ayar/GetAyar', { headers: AuthService.getHeaders() });

            if (result && result.data) {
                setKisiGizlilikMetni(result.data.value.kisiGizlilikMetni);
                setGenelCevapMetni(result.data.value.genelCevapMetni);
                setMailSablonYeniSifre(result.data.value.mailSablonYeniSifre);
                setMailSablonSifreYenileme(result.data.value.mailSablonSifreYenileme);
                setMailSablonBildirim(result.data.value.mailSablonBildirim);
            }
        } catch (error) {
            toast.error(error);
            /*if (error.status === 401) {
                
                //window.location = '/';
            } else {
                toast.error(error);
            }*/           
        }
    }

    const Kaydet = async () => {
        if (await tokenYenile() === false) {
            return;
        }
        
        if (kisiGizlilikMetni === "") {
            Swal.fire({ title: "Hata", text: "Lütfen zorunlu alanları doldurunuz", icon: "error" });
        } else {
            try {
                const data = JSON.stringify({
                    "kisiGizlilikMetni": kisiGizlilikMetni,
                    "genelCevapMetni": genelCevapMetni,
                    "mailSablonYeniSifre": mailSablonYeniSifre,
                    "mailSablonSifreYenileme": mailSablonSifreYenileme,
                    "mailSablonBildirim": mailSablonBildirim,
                    "eMailSunucusu": "",
                    "eMailGonderenAdres": "",
                    "eMailGonderenSifre": "",
                    "eMailPort": 0,
                    "eMailSSL": false
                });

                const result = await axios.post(settings.ApiUrl + 'Ayar/InsertOrUpdateAyar/', data, { headers: AuthService.getHeaders() });

                if (result.data.success) {
                    toast.success("Kaydedildi");
                } else {
                    toast.error(result.data.message);
                }
            } catch (error) {
                toast.error(error);
            }
        }
    }

    return (
        <Fragment>

            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>

            <PageTitle></PageTitle>

            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <div>
                                <ul className="nav nav-tabs mb-3">
                                    <li className="nav-item">
                                        <button className={tab === "Metin" ? "nav-link active" : "nav-link"} onClick={() => setTab("Metin")}>Metinler</button>
                                    </li>
                                    <li className="nav-item">
                                        <button className={tab === "MailSablon" ? "nav-link active" : "nav-link"} onClick={() => setTab("MailSablon")}>E-Posta Şablonları</button>
                                    </li>
                                </ul>

                                {
                                    tab === "Metin" ?
                                        <div className="card info-card mb-2">
                                            <div className="card-body mt-3">
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <label id="lblKisiGizlilikMetniKonu" className="form-label fw-bold">Kişisel Gizlik Bildirim Metni</label>
                                                        <textarea htmlFor="lblKisiGizlilikMetni" rows={10} className="form-control form-control-sm" value={kisiGizlilikMetni} onChange={(e) => setKisiGizlilikMetni(e.target.value)}></textarea>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label id="lblGenelCevapMetni" className="form-label fw-bold">Genel Başvuru Cevap Metni</label>
                                                        <textarea htmlFor="lblGenelCevapMetni" rows={10} className="form-control form-control-sm" value={genelCevapMetni} onChange={(e) => setGenelCevapMetni(e.target.value)}></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        ""
                                }

                                {
                                    tab === "MailSablon" ?
                                        <div className="card info-card mb-2">
                                            <div className="card-body mt-3">
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <label id="lblMailSablonYeniSifre" className="form-label fw-bold">Kullanıcı Oluşturma E-Posta Şablonu</label>
                                                        <div htmlFor="lblMailSablonYeniSifre">
                                                            <JoditEditor config={joditToolbar} value={mailSablonYeniSifre} onChange={(e) => setMailSablonYeniSifre(e)}></JoditEditor>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <label id="lblMailSablonSifreYenileme" className="form-label fw-bold">Şifre Yenileme E-Posta Şablonu</label>
                                                        <div htmlFor="lblMailSablonSifreYenileme">
                                                            <JoditEditor config={joditToolbar} value={mailSablonSifreYenileme} onChange={(e) => setMailSablonSifreYenileme(e)}></JoditEditor>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label id="lblMailSablonBildirim" className="form-label fw-bold">Bildirim E-Posta Şablonu</label>
                                                        <div htmlFor="lblMailSablonBildirim">
                                                            <JoditEditor config={joditToolbar} value={mailSablonBildirim} onChange={(e) => setMailSablonBildirim(e)}></JoditEditor>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        ""
                                }

                                {
                                    yetkiKaydet === true ?
                                        <div className="col-md-12 mt-3">
                                            <button className="btn btn-success w-100" onClick={Kaydet}><i className="bi bi-check-lg"></i> Kaydet</button>
                                        </div>
                                        :
                                        ""
                                }
                            </div>
                        :
                        ""
            }

        </Fragment>
    );
};

export default Ayar;